import template from "./name-or-contact.html";
import "./name-or-contact.less";
import contactInfo from "../../contact-info";
import * as angular from "angular";

import { isSupportedOrNullish } from "../isSupportedOrNullish";
import {
	ENTITY_TRANSLATION_KEYS, 
	I18NextContext 
} from "../../../services/i18nService";

export function controller($uibModal, $logger, $scope) {
	const ctrl = this;

	ctrl.editContact = editContact;
	ctrl.i18n = I18NextContext.Instance;
	ctrl.ENTITY_TRANSLATION_KEYS = ENTITY_TRANSLATION_KEYS;

	ctrl.$onInit = () => {
		const defaultName = `${ctrl.typeConfig.Code} ${ctrl.typeConfig.Code === "FISHERMAN" && !!ctrl.typeConfig.Name ? "Info" : "Name"}`;
		ctrl.tooltipTranslations = {
			name: ctrl.i18n.translateEntityType(ctrl.typeConfig.Code, ENTITY_TRANSLATION_KEYS.LABELS.Name, defaultName)
		};
		
		determineSwitchability();
		
		$scope.$watch(() => ctrl.contact, pickNameComponent);
		$scope.$watch(() => ctrl.name, pickNameComponent);
	};

	function determineSwitchability() {
		if(ctrl.nameComponentOptions !== undefined) {
			ctrl.nameComponentSwitchable = ctrl.nameComponentOptions.text === "allowed"
				|| ctrl.nameComponentOptions.contact === "allowed";
		}
		else if(ctrl.typeConfig.Contact !== undefined) {
			ctrl.nameComponentSwitchable =
				ctrl.contact === undefined
				&& !ctrl.typeConfig.Contact.IsRequired && !!ctrl.typeConfig.Contact.IsSupported;
		}
		else {
			ctrl.nameComponentSwitchable = false;
		}
	}

	function pickNameComponent() {
		determineSwitchability();
		if(ctrl.nameComponentOptions !== undefined) {
			ctrl.useNameComponent = ctrl.nameComponentOptions.text === "default" ? "text"
					: ctrl.nameComponentOptions.contact === "default" ? "contact"
					: undefined;
		}
		else if(ctrl.typeConfig.Contact !== undefined) {
			ctrl.useNameComponent = !ctrl.typeConfig.Contact.IsSupported ? "text" 
				: ctrl.name !== undefined && ctrl.contact === undefined ? "text"
				: "contact";
		}
		else {
			ctrl.useNameComponent = "text";
		}
	}

	ctrl.switchNameType = () => {
		if(ctrl.useNameComponent === "contact") {
			ctrl.useNameComponent = "text";
		}
		else {
			ctrl.useNameComponent = "contact";
		}
	};

	ctrl.isSupportedOrNullish = isSupportedOrNullish;

	function editContact() {
		$uibModal.open({
			component: "contact-info-modal",
			backdrop: "static",
			size: "sm",
			resolve: {
				contact: () => ctrl.contact,
				isReadonly: () => ctrl.isReadonly
			}
		}).result
			.then((contact) => {
				ctrl.contact = { ...contact };
				ctrl.name = `${contact.FirstName} ${contact.LastName}`;
			});
	}
}

export default angular.module("vesl.components.name-or-contact", [contactInfo])
	.component("nameOrContact", {
		controller,
		template,
		bindings: {
			name: "=",
			contact: "=",
			isReadonly: "<",
			typeConfig: "<",
			nameComponentOptions: "<"
		}
	})
	.name;
